import { render } from "./EmergencyContactsRow.vue?vue&type=template&id=e1486506&ts=true"
import script from "./EmergencyContactsRow.ts?vue&type=script&lang=ts&external"
export * from "./EmergencyContactsRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__